//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import vClickOutside from 'v-click-outside'
import SearchSelect from '~/components/partials/search_select'
import ComparePrice from '@/components/detail/mobile/compare_price'
import DetailInfosection from '~/components/detail/desktop/detail_infosection'
import DetailMoreInfosection from '~/components/detail/desktop/detail_more_infosection'
// import DetailInfo from '@/components/detail/mobile/detail_info'
// import DetailMoreinfo from '@/components/detail/mobile/detail_moreinfo'
export default {
  name: 'DetailCoin',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    SearchSelect,
    ComparePrice,
    DetailInfosection,
    DetailMoreInfosection
    // DetailInfo,
    // DetailMoreinfo
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showMore: false,
      showDropdown: false
    }
  },
  computed: {
    ...mapGetters({
      buyDollarPrice: 'coins/buyDollarPrice',
      isGuest: 'auth/isGuest',
      coins: 'coins/coins'
    }),
    inWatchList () {
      const index = this.$store.getters['watchList/watchList'].findIndex(i => i.symbol === this.data.symbol)
      if (index >= 0) {
        return true
      }
      return false
    }
  },
  watch: {
    '$ref.mySheet.open' () {
      alert('a')
      this.showDropdown = !this.showDropdown
    }
  },
  methods: {
    watchListClick () {
      if (this.isGuest) {
        const router = this.$router.resolve({ path: '/my/auth/login' })
        window.open(router.href, '_self')
      } else {
        this.$store.dispatch(this.inWatchList ? 'watchList/removeFavorite' : 'watchList/addFavorite', this.data)
      }
    },
    hidden () {
      this.showDropdown = false
    },
    selectOption (coin) {
      this.showDropdown = false
      this.$refs.mySheet.close()
    },
    open () {
      this.showDropdown = true
      this.$refs.mySheet.open()
    }
  }
}
